import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UserResponse } from "~types/user";
import { transformUserDetailsResponse } from "../utilities";

const useFetchUser = () => {
  const request = useApi();
  const { organizationId, sport, userId } = useParams();

  return useQuery({
    queryKey: ["permission-users", sport, organizationId, userId],
    queryFn: () => request<UserResponse>(`${sport}/o/${organizationId}/users/${userId}`).then(transformUserDetailsResponse),
  });
};

export default useFetchUser;
